import http from '@/utils/http';

//获取选择题
export const getChoiceQuestion = (data: any, url: string) => {
  return http({
    url: url ? url : '/talent/test/dot/getChoiceQuestion',
    method: 'get',
    params: data
  });
};

//提交选择题
export const completeChoiceTest = (data: any, url: string) => {
  return http({
    url: url ? url : '/talent/test/dot/completeChoiceTest',
    method: 'post',
    data
  });
};
//获取打标题
export const getMarkQuestion = (data: any, url: string) => {
  return http({
    url: url ? url : '/talent/test/dot/getMarkQuestion',
    method: 'get',
    params: data
  });
};

//提交打标题
export const completeMarkTest = (data: any, url: string) => {
  return http({
    url: url ? url : '/talent/test/dot/completeMarkTest',
    method: 'post',
    data
  });
};

//获取申请信息
export const getApplyInfo = (data: any, url: string) => {
  return http({
    url: url ? url : '/talent/test/dot/getApplyInfo',
    method: 'get',
    params: data
  });
};

//去测试
export const goToTest = (data: any) => {
  return http({
    url: '/talent/cheat/test/goToTest',
    method: 'post',
    params: data
  });
};

//开始考试(生成题目，创建测试记录)
export const startTest = (data: any) => {
  return http({
    url: '/talent/cheat/test/startTest',
    method: 'post',
    params: data
  });
};
